var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { useState } from 'react';
import axios from 'axios';
import ComponentConditionsModal from '../../Components/ComponentConditionsModal';
import T from '../../Utils/Locale';
const RequireConditionsAcceptance = () => {
    const [isLoading, toggleLoading] = useState(false);
    const onAccept = () => __awaiter(void 0, void 0, void 0, function* () {
        toggleLoading(true);
        const response = yield axios.get('/api/user/accept-conditions');
        if (response.status !== 200) {
            window.alert(T('conditions.failed'));
            return;
        }
        window.location.reload();
    });
    return (_jsx(ComponentConditionsModal, { title: T('conditions.title_updated'), isLoading: isLoading, onDecline: () => window.alert(T('conditions.required')), onAccept: onAccept }));
};
export default RequireConditionsAcceptance;
